// Actions
import { RECEIVE_PROGRAMS, REQUEST_ERROR } from './actions';
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var newState = state;

  switch (action.type) {
    case RECEIVE_PROGRAMS:
      newState = action.program;
      break;

    case REQUEST_ERROR:
    default:
      break;
  } // Return the new state.


  return newState;
});